export function target() {
  return this.module === 'Contact';
}

export function migrate({ emails, emailsLegacy }) {
  const { subjects } = this.data;
  const settingsEmail = emailsLegacy || emails;

  subjects.forEach((subject) => {
    if (!subject.emails) {
      // eslint-disable-next-line no-param-reassign
      subject.emails = [];
      return;
    }

    if (subject.emails.length > 0 && subject.emails[0].includes('@')) {
      return;
    }

    const emailList = [];

    subject.emails.forEach((emailId) => {
      const emailValue = settingsEmail[emailId];

      if (emailValue) {
        emailList.push(emailValue);
      }
    });

    // eslint-disable-next-line no-param-reassign
    subject.emails = emailList;
  });
}
